import { render, staticRenderFns } from "./clients-filter.vue?vue&type=template&id=c22dd35e&"
import script from "./clients-filter.vue?vue&type=script&lang=js&"
export * from "./clients-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports